import Star from 'lucide-react/dist/esm/icons/star';

interface StarRatingProps {
  rating: number;
  interactive?: boolean;
  size?: 'sm' | 'md' | 'lg';
  onRatingChange?: (rating: number) => void;
}

const sizeClasses = {
  sm: 'w-4 h-4',
  md: 'w-5 h-5',
  lg: 'w-6 h-6',
};

export default function StarRating({
  rating,
  interactive = false,
  size = 'md',
  onRatingChange,
}: StarRatingProps) {
  const handleRatingClick = (newRating: number) => {
    if (interactive && onRatingChange) {
      onRatingChange(newRating);
    }
  };

  return (
    <div
      className="flex gap-1"
      role={interactive ? 'radiogroup' : undefined}
      {...(interactive && { 'aria-label': 'דירוג' })}
    >
      {Array.from({ length: 5 }, (_, i) => i + 1).map((starValue) => (
        <button
          key={`star-${starValue}`}
          type="button"
          onClick={() => handleRatingClick(starValue)}
          disabled={!interactive}
          className={`transition-colors ${
            interactive ? 'cursor-pointer hover:scale-110' : 'cursor-default'
          }`}
          role={interactive ? 'radio' : 'img'}
          {...(interactive && { 'aria-checked': starValue <= rating })}
          aria-label={interactive ? `דירוג ${starValue} כוכבים` : undefined}
        >
          <Star
            className={`${sizeClasses[size]} ${
              starValue <= rating
                ? 'fill-yellow-400 text-yellow-400'
                : interactive
                  ? 'text-gray-300 hover:text-yellow-300'
                  : 'text-gray-300'
            }`}
          />
        </button>
      ))}
    </div>
  );
}
